import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SwitchWrapper = styled.label`
  position: relative;
  display: inline-block;
  width: 70px;
  height: 30px;
`;
const Input = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.theme.carvana.blue};
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 3px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }

  ${Input}:checked + & {
    background-color: ${props => props.theme.carvana.blue};

    &:before {
      transform: translateX(37px);
    }
  }

  ${Input}:focus + & {
    box-shadow: 0 0 1px ${props => props.theme.carvana.blue};
  }
`;
const Wrapper = styled.div`
  padding: 1rem 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Text = styled.span`
  font-size: 21px;
  line-height: 23px;
  color: #333;
  font-weight: 700;
  padding: 0 1rem 5px;
`;

class SwitchSlider extends PureComponent {
  static propTypes = {
    leftText: PropTypes.string.isRequired,
    rightText: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    isChecked: PropTypes.bool
  };

  static defaultProps = {
    isChecked: false
  };

  state = {
    isChecked: this.props.isChecked
  };

  toggleCheckbox = () => {
    const { onChange } = this.props;
    this.setState(
      ({ isChecked }) => ({ isChecked: !isChecked }),
      () => {
        const { isChecked } = this.state;
        if (onChange) {
          onChange(isChecked);
        }
      }
    );
  };

  render() {
    const { leftText, rightText } = this.props;
    const { isChecked } = this.state;

    return (
      <Wrapper>
        <Text>{leftText}</Text>

        <SwitchWrapper>
          <Input
            type="checkbox"
            checked={isChecked}
            onChange={this.toggleCheckbox}
          />

          <Slider />
        </SwitchWrapper>

        <Text>{rightText}</Text>
      </Wrapper>
    );
  }
}

export default SwitchSlider;
